import { useMemo, type FC } from 'react';

import { useFeature } from '../../../../services/features/reactBindings/hooks';
import { useIsLargerThanWide } from '../../../../styles/hooks/media';
import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';
import { GameButtonWithTooltip } from '../../../game/gameButton/gameButton';
import type { TooltipProps } from '../../../tooltip/Tooltip';

import styles from './QuickGuide.module.css';

interface QuickGuideControlPlainProps {
  onClick: () => void;
  active: boolean;
  timer: number;
}

export const QuickGuideControl: FC<QuickGuideControlPlainProps> = ({ active, timer, onClick }) => {
  const isWide = useIsLargerThanWide();
  const newMobileLayout = useFeature('newMobileLayout');

  const tooltipOptions: TooltipProps = useMemo(() => {
    return {
      text: 'QG_QUICK_GUIDE',
      position: isWide ? TooltipPositions.Bottom : TooltipPositions.Right,
      forceOpen: timer !== 0,
      displayOnTouch: true,
      displayTrigger: timer !== 0,
    };
  }, [isWide, timer]);

  return !newMobileLayout || isWide ? (
    <div className={!isWide ? styles.quickGuideIcon_legacy : undefined}>
      <IconButtonWithTooltip
        data-testid="quick-guide-button"
        icon={Icons.Guide}
        active={active}
        timer={timer}
        onClick={onClick}
        autoCall={false}
        large={!isWide}
        tooltipOptions={tooltipOptions}
      />
    </div>
  ) : (
    <GameButtonWithTooltip
      data-testid="quick-guide-button"
      icon={Icons.Guide}
      active={active}
      onClick={onClick}
      timerDuration={timer}
      tooltipOptions={tooltipOptions}
    />
  );
};
